import { HostsView } from './view'
import { ScreenError, ScreenLoading } from '../../components/state'
import { t } from '../../copy'
import { T } from '../../copy/text'
import {
  useAcceptSuggestion,
  useAssignHostToProject,
  useHosts,
  useProjects,
  useUnassignedHosts,
} from '../../app/queries'

/**
 * 机器列表。
 *
 * 这一屏要守住的一条产品原则：**没归项目的机器一样被巡检、一样告警。**
 * 所以顶上那条琥珀提示是「你确认一下就好」，不是「请先分类」——
 * 它是个建议，不是个必填项，页面的其余部分完全不受它影响。
 *
 * 琥珀条的台数与列出的卡片必须来自同一份 `GET /hosts?unassigned=true`，
 * 不能用列表页那个会过期的 `unassigned_count`（一页只给得出 1 台，
 * 条上却写 6 台）。
 */
export function HostsScreen() {
  const hosts = useHosts()
  const unassigned = useUnassignedHosts()
  const projects = useProjects()
  const accept = useAcceptSuggestion()
  const assign = useAssignHostToProject()

  if (hosts.isPending) return <ScreenLoading shape="cards" cols={2} />
  if (hosts.error) {
    return (
      <ScreenError
        title={<T id="host.list.title" />}
        error={hosts.error}
        onRetry={() => void hosts.refetch()}
      />
    )
  }
  if (!hosts.data) return <ScreenError error={new Error(t('error.generic'))} />

  return (
    <HostsView
      hosts={hosts.data.items}
      unassignedHosts={unassigned.data?.items ?? []}
      totalCount={hosts.data.total_count}
      projects={projects.data?.items ?? []}
      onAcceptSuggestion={(hostId, what) => accept.mutate({ hostId, what })}
      onAssignProject={(hostId, projectId) => assign.mutate({ hostId, projectId })}
      acceptingHostId={accept.isPending ? accept.variables?.hostId : undefined}
      assigningHostId={assign.isPending ? assign.variables?.hostId : undefined}
    />
  )
}
